import { render, staticRenderFns } from "./AppStoreUpdateReviewStatus.vue?vue&type=template&id=1e566496&scoped=true"
import script from "./AppStoreUpdateReviewStatus.vue?vue&type=script&lang=js"
export * from "./AppStoreUpdateReviewStatus.vue?vue&type=script&lang=js"
import style0 from "./AppStoreUpdateReviewStatus.vue?vue&type=style&index=0&id=1e566496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e566496",
  null
  
)

export default component.exports